module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "5px",
      "padding": "0px 5px"
    }
  }, [(_vm.fieldInfo.type == _vm.types.INPUT) ? _c('div', [_c('input-box', {
    attrs: {
      "data": _vm.fieldInfo,
      "value": _vm.valinfo,
      "option": _vm.optionInfo,
      "read": _vm.readOnly
    },
    on: {
      "error_msg": _vm.onErrorMsg,
      "on_update": _vm.onUpdate
    }
  })], 1) : (_vm.fieldInfo.type == _vm.types.EMAIL) ? _c('div', [_c('email-box', {
    attrs: {
      "data": _vm.fieldInfo,
      "value": _vm.valinfo,
      "option": _vm.optionInfo,
      "read": _vm.readOnly
    },
    on: {
      "on_update": _vm.onUpdate
    }
  })], 1) : (_vm.fieldInfo.type == _vm.types.SELECT_BOX) ? _c('div', [_c('select-box', {
    attrs: {
      "data": _vm.fieldInfo,
      "value": _vm.valinfo,
      "option": _vm.optionInfo,
      "read": _vm.readOnly
    },
    on: {
      "on_update": _vm.onUpdate
    }
  })], 1) : (_vm.fieldInfo.type == _vm.types.SELECT_BOX2) ? _c('div', [_c('select-box2', {
    attrs: {
      "data": _vm.fieldInfo,
      "value": _vm.valinfo,
      "option": _vm.optionInfo,
      "read": _vm.readOnly
    },
    on: {
      "on_update": _vm.onUpdate
    }
  })], 1) : (_vm.fieldInfo.type == _vm.types.SELECT_BOX3) ? _c('div', [_c('select-box3', {
    attrs: {
      "data": _vm.fieldInfo,
      "value": _vm.valinfo,
      "option": _vm.optionInfo,
      "read": _vm.readOnly
    },
    on: {
      "on_update": _vm.onUpdate
    }
  })], 1) : (_vm.fieldInfo.type == _vm.types.SELECT_BOX4) ? _c('div', [_c('select-box4', {
    attrs: {
      "data": _vm.fieldInfo,
      "value": _vm.valinfo,
      "option": _vm.optionInfo,
      "read": _vm.readOnly
    },
    on: {
      "on_update": _vm.onUpdate
    }
  })], 1) : (_vm.fieldInfo.type == _vm.types.DATE_PICKER || _vm.fieldInfo.type == _vm.types.CURRENT_TIME) ? _c('div', [(_vm.fakeDate()) ? _c('input-box', {
    attrs: {
      "data": _vm.fieldInfo,
      "value": _vm.valinfo,
      "option": _vm.optionInfo,
      "read": _vm.readOnly
    }
  }) : _c('date-box', {
    attrs: {
      "data": _vm.fieldInfo,
      "value": _vm.valinfo,
      "option": _vm.optionInfo,
      "read": _vm.readOnly
    }
  })], 1) : (_vm.fieldInfo.type == _vm.types.DATETIME_PICKER) ? _c('div', [(_vm.fakeDate()) ? _c('input-box', {
    attrs: {
      "data": _vm.fieldInfo,
      "value": _vm.valinfo,
      "option": _vm.optionInfo,
      "read": _vm.readOnly
    }
  }) : _c('datetime-box', {
    attrs: {
      "data": _vm.fieldInfo,
      "value": _vm.valinfo,
      "option": _vm.optionInfo,
      "read": _vm.readOnly
    }
  })], 1) : (_vm.fieldInfo.type == _vm.types.PASSWORD) ? _c('div', [_c('password-box', {
    attrs: {
      "data": _vm.fieldInfo,
      "value": _vm.valinfo,
      "option": _vm.optionInfo,
      "read": _vm.readOnly
    }
  })], 1) : (_vm.fieldInfo.type == _vm.types.RADIO_BUTTON) ? _c('div', [_c('radio-button', {
    attrs: {
      "data": _vm.fieldInfo,
      "value": _vm.valinfo,
      "option": _vm.optionInfo,
      "read": _vm.readOnly
    }
  })], 1) : (_vm.fieldInfo.type == _vm.types.TEXT_AREA) ? _c('div', [_c('text-area', {
    attrs: {
      "data": _vm.fieldInfo,
      "value": _vm.valinfo,
      "option": _vm.optionInfo,
      "read": _vm.readOnly
    }
  })], 1) : (_vm.fieldInfo.type == _vm.types.CHECKBOX) ? _c('div', [_c('checkbox', {
    attrs: {
      "data": _vm.fieldInfo,
      "value": _vm.valinfo,
      "option": _vm.optionInfo,
      "read": _vm.readOnly
    }
  })], 1) : (_vm.fieldInfo.type == _vm.types.SPACE) ? _c('div', [_vm._m(0)]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showError),
      expression: "showError"
    }],
    style: ('color:white;margin:2px 0px;padding:2px 5px;text-align: end; width: 90%;float: right;background-color:' + ((_vm.errorMode == 'restrict') ? '#de5201;' : 'orange;'))
  }, [_vm._v(_vm._s(_vm.errorMsg))])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group esma_form_group"
  }, [_c('br')])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-52f2543e","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/form-field.vue
// module id = 986
// module chunks = 0